import { createContext, useContext } from 'react'
import type { Actor, PublicConfig } from './types'

export type AppContextValue = {
  config:PublicConfig
  actor:Actor|null
  refreshActor:()=>Promise<void>
  signOut:()=>Promise<void>
}

export const AppContext = createContext<AppContextValue|null>(null)

export function useApp() {
  const value = useContext(AppContext)
  if (!value) throw new Error('App context missing')
  return value
}
